import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { IpGeoResponse } from '@/pages/api/proxy';
import useListenFromRn from './useListenFromRn';
export default function useGetLocation() {
  const [geoCountry, setGeoCountry] = useLocalStorage('geoCountry', '');
  const [geoState, setGeoState] = useLocalStorage('geoState', '');
  const {
    sendMessageToRN
  } = useListenFromRn();
  const {
    data
  } = useQuery({
    queryKey: ['userLocation'],
    queryFn: async (): Promise<IpGeoResponse> => {
      const locationResponse = await fetch('/api/proxy');
      const locationData = await locationResponse.json();
      return locationData;
    },
    staleTime: 1000 * 60 * 10
  });
  useEffect(() => {
    const country = data?.country_code;
    const state = data?.region_code;
    sendMessageToRN({
      action: 'DATA_IP_ADDRESS',
      payload: {
        ip: data?.ip,
        latitude: data?.latitude,
        longitude: data?.longitude
      }
    });
    if (!data) return;
    setGeoCountry(country);
    setGeoState(state);
  }, [data]);
  return {
    data,
    geoCountry,
    geoState
  };
}